import { lazy } from "react";
import type { RouteObject } from "react-router";

const IndexPage = lazy(() => import("src/pages/blog/index"));
const DetailsPage = lazy(() => import("src/pages/blog/detail"));

export const blogRoutes: RouteObject[] = [
  {
    path: "blog",
    children: [
      {
        index: true,
        element: <IndexPage />,
      },
      {
        path: "details/:title",
        element: <DetailsPage />,
      },
    ],
  },
];
